/**
 * AppLayout Component
 * 
 * Main layout wrapper for the application that includes common UI elements
 * like header, footer, and main content area.
 */
import { Outlet } from 'react-router-dom'
import Header from './header'
import Footer from './footer'
import useAuthStateListener from '@/hooks/useAuthStateListener'

function AppLayout() {
  // Initialize auth state listener for persistence
  useAuthStateListener()
  
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Header */}
      <Header />

      {/* Main content */}
      <main className="flex-grow container mx-auto px-4 py-6">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default AppLayout
